const WHY = [
  {
    icon: 'ri-service-line',
    title: 'End-to-End Managed',
    description: 'We handle everything — identification, bidding, legal filings, and ongoing tracking. You never have to attend an auction or file a single document.',
  },
  {
    icon: 'ri-map-pin-user-line',
    title: 'Licensed in All 3 States',
    description: 'Our specialists are certified in California, Nevada, and Arizona with deep local expertise in each state\'s unique acquisition procedures and legal requirements.',
  },
  {
    icon: 'ri-scales-3-line',
    title: 'Legal & Compliance',
    description: 'Every acquisition is fully compliant with state-specific statutes. Our legal team ensures clean title transfer and handles all post-acquisition documentation.',
  },
  {
    icon: 'ri-dashboard-3-line',
    title: 'Transparent Reporting',
    description: 'Real-time dashboard access to all your active certificates, acquisition statuses, redemption timelines, and projected returns. No black boxes.',
  },
  {
    icon: 'ri-time-line',
    title: 'Priority Access',
    description: 'Pro and Elite members receive pre-auction intelligence 30-90 days in advance, giving your portfolio first pick of qualifying opportunities.',
  },
  {
    icon: 'ri-team-line',
    title: 'Expert Advisor Access',
    description: 'Elite members get a dedicated acquisition specialist who learns your portfolio goals and proactively surfaces the best matching opportunities.',
  },
];

export default function WhyChooseUs() {
  return (
    <section className="bg-[#090b10] py-24">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        {/* Header */}
        <div className="flex flex-col lg:flex-row gap-12 mb-16">
          <div className="lg:w-1/2">
            <span className="inline-block px-4 py-1.5 border border-gold/25 text-gold text-xs font-semibold tracking-widest uppercase rounded-full mb-5">
              Why Members Choose Us
            </span>
            <h2 className="font-playfair text-4xl md:text-5xl font-bold text-white leading-tight">
              A Service You Can<br />
              Trust With Your<br />
              <span className="text-gold">Capital.</span>
            </h2>
          </div>
          <div className="lg:w-1/2 flex items-center">
            <p className="text-white/45 text-lg leading-relaxed">
              We&apos;re not a listing site. We&apos;re an active acquisition service — our specialists are in the field every week attending auctions, filing documents, and securing certificates that grow your portfolio.
            </p>
          </div>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {WHY.map((item, idx) => (
            <div
              key={idx}
              className="group bg-surface-2 border border-white/6 rounded-2xl p-7 hover:border-gold/20 transition-all duration-300"
            >
              <div className="w-11 h-11 flex items-center justify-center rounded-xl bg-gold/8 border border-gold/15 mb-5 group-hover:bg-gold/15 transition-colors">
                <i className={`${item.icon} text-gold text-xl`} />
              </div>
              <h3 className="font-playfair text-xl font-bold text-white mb-3">{item.title}</h3>
              <p className="text-white/40 text-sm leading-relaxed">{item.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
